<template>
  <dialog
    :id="id"
    class="dialog-container bg-black rounded-md absolute ml-auto m-0 top-10 right-10 z-20"
  >
    <slot name="dialog" />
  </dialog>
</template>

<script setup>
import { ref, watch, toRefs } from "vue";

const props = defineProps({
  id: {
    type: String,
    default: undefined
  },
  showDialog: {
    type: Boolean,
    default: false
  },
  width: {
    type: String,
    default: ""
  },
  height: {
    type: String,
    default: ""
  }
});
const dialogOpen = ref(false);
const { showDialog, width, height } = toRefs(props);

watch(showDialog, () => toggleDialog(props.id));
const toggleDialog = id => {
  dialogOpen.value = !dialogOpen.value;
  let dialog = document.getElementById(id);
  dialog.open = dialogOpen.value;
};
</script>

<style scoped>
.dialog-container {
  width: v-bind(width);
  height: v-bind(height);
}
</style>
